import { Component, OnInit } from '@angular/core';
import { JhiLanguageService } from 'ng-jhipster';

import { Principal } from '../../shared';
import { Password } from './password.service';
import { PASSWORD_INPUT_CLASS } from '../../shared/constants/password.constants';
import { StudentService, Student } from '../../entities/student/';

@Component({
    selector: 'jhi-password',
    templateUrl: './password.component.html'
})
export class PasswordComponent implements OnInit {
    doNotMatch: string;
    error: string;
    success: string;
    account: any;
    password: string;
    confirmPassword: string;
    showPassword: boolean;
    passwordInputClass: string;
    showConfirmPassword: boolean;
    confirmPasswordInputClass: string;
    student: Student;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private passwordService: Password,
        private principal: Principal,
        private studentService: StudentService,
    ) {
        this.jhiLanguageService.setLocations(['password']);
    }

    ngOnInit() {
        this.principal.identity().then((account) => {
            this.account = account;
            // we load the student in case the maintenanance mode is on.
            // calling the student api will force to show the maintenance page
            this.loadStudent();
        });
        this.showPassword = false;
        this.passwordInputClass = PASSWORD_INPUT_CLASS.HIDE;
        this.showConfirmPassword = false;
        this.confirmPasswordInputClass = PASSWORD_INPUT_CLASS.HIDE;
    }

    toggleShowPassword(event: MouseEvent) {
        this.showPassword = !this.showPassword;
        this.passwordInputClass = this.showPassword ? PASSWORD_INPUT_CLASS.SHOW : PASSWORD_INPUT_CLASS.HIDE;

        // this is to not launch login upon click
        event.preventDefault();
    }

    toggleShowConfirmPassword(event: MouseEvent) {
        this.showConfirmPassword = !this.showConfirmPassword;
        this.confirmPasswordInputClass = this.showConfirmPassword ? PASSWORD_INPUT_CLASS.SHOW : PASSWORD_INPUT_CLASS.HIDE;

        // this is to not launch login upon click
        event.preventDefault();
    }

    onKeyDown(event: KeyboardEvent): void {
        // this is to toggle show text upon enter key but do login
         if (event.key === 'Enter') {
          event.preventDefault();
        }
    }

    changePassword() {
        if (this.password !== this.confirmPassword) {
            this.error = null;
            this.success = null;
            this.doNotMatch = 'ERROR';
        } else {
            this.doNotMatch = null;
            this.passwordService.save(this.password).subscribe(() => {
                this.error = null;
                this.success = 'OK';
            }, () => {
                this.success = null;
                this.error = 'ERROR';
            });
        }
    }

    loadStudent() {
        this.studentService.getCurrent()
        .subscribe(
            (student: Student) => {
                this.student = student;
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/password/password.component.ts